module.exports = __webpack_public_path__ + "static/media/attachment.899ab43e.svg";